import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type MemberProfile } from "./types";

const reducer = (state: MemberProfile.AppState = defaultState, action: ReduxAction<any>): MemberProfile.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { profile } = action.data as InitSuccessActionData;
      return {
        ...state,
        fieldError: null,
        hasProfile: !!profile,
        profile: profile ?? state.profile,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: MemberProfile.AppState = {
  error: null,
  fieldError: null,
  hasProfile: false,
  profile: {
    city: "",
    countryCode: "",
    cultureCode: "",
    currencyCode: "",
    email: "",
    firstName: "",
    lastName: "",
    payPalEmail: "",
    postalCode: "",
    profilePictureMediaId: null,
    profilePictureMediaSourceId: null,
    profilePictureMediaSourceKey: null,
    street: "",
    telephone: "",
    timeZoneKey: "",
    unit: "",
    userId: -1
  },
  id: "",

  status: Status.None
};
export const previewState: MemberProfile.AppState = {
  ...defaultState,
  hasProfile: true,
  profile: {
    city: "",
    countryCode: "",
    cultureCode: "",
    currencyCode: "",
    email: "",
    firstName: "Dummy",
    lastName: "Dummy",
    payPalEmail: "",
    postalCode: "",
    profilePictureMediaId: null,
    profilePictureMediaSourceId: null,
    profilePictureMediaSourceKey: null,
    street: "",
    telephone: "",
    timeZoneKey: "",
    unit: "",
    userId: -1
  },
  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState });
